
import axios from 'axios'
import request from '../utils/request'

export class DownLoadApi {
  static DownLoadUrl = {
    exportUrl: '/task/export/create',
    queryExportFileUrl: '/task/export/query',
    queryTaskStatusUrl: '/task/export/taskStatus',
    queryTaskSourceUrl: '/task/export/taskSource',
    queryTaskDetailListUrl: '/task/export/taskList'
  }


  static DownLoadExportFile (param, typeVal) {
    request({
      url: DownLoadApi.DownLoadUrl.exportUrl,
      method: 'post',
      params: {
        taskParameterJson: param,
        taskType: typeVal
      }
    }).then(response => {
      return response
    })
  }

  static QueryExportProcess (taskId) {
    request({
      url: DownLoadApi.DownLoadUrl.queryExportFileUrl,
      method: 'post',
      params: {
        taskId: taskId
      }
    }).then(response => {
      return response
    })
  }

  /**
   * 下载事件
   *
   */
  static DownLoadTemplateFile (url, params) {
    axios.post(url, params, {
      responseType: 'blob'
    }).then(response => {
      var blob = new Blob([response.data], {
        type: 'application/vnd.ms-excel' })
      var downloadElement = document.createElement('a')
      var href = window.URL.createObjectURL(blob) // 创建下载的链接
      downloadElement.href = href
      downloadElement.download = params.get('filename') // 下载后文件名
      document.body.appendChild(downloadElement)
      downloadElement.click() // 点击下载
      document.body.removeChild(downloadElement) // 下载完成移除元素
      window.URL.revokeObjectURL(href) // 释放掉blob对象
    }).catch((error) => {
      console.log(error)
    })
  }
}



// WEBPACK FOOTER //
// ./src/js/DownLoadApi.js